new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {



    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const widgetNutrients = document.querySelector('#widget-nutrients');
    if (widgetNutrients) {
        $('#widget-nutrients').slick({
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            delay: 2000,
            speed: 700,

            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    }

    waitForElementToExist('.slick-category').then(element => {
        const widgetCategory = element.querySelector('#widget-category');
        if (widgetCategory) {
            $('#widget-category').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                speed: 700,
            });
        }
    });

    waitForElementToExist('.second-slick-category').then(element => {
        const widgetCategory = element.querySelector('#widget-category-2');
        if (widgetCategory) {
            $('#widget-category-2').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                speed: 700,
            });
        }
    });

    waitForElementToExist('.third-slick-category').then(element => {
        const widgetCategory = element.querySelector('#widget-category-3');
        if (widgetCategory) {
            $('#widget-category-3').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                speed: 700,
            });
        }
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if (firstCarrousel) {
            $('.product_list').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 577,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.product-ratings').then(element => {
        const productRatings = element.querySelector('.product-ratings-list');
        if (productRatings) {
            $('.product-ratings-list').slick({
                arrows: true,
                prevArrow: $(".product-ratings .arrows .prev"),
                nextArrow: $(".product-ratings .arrows .next"),
                dots: true,
                adaptiveHeight: true,
                autoplay: false,
                autoplaySpeed: 2500,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                            adaptiveHeight: true,
                        }
                    },
                    {
                        breakpoint: 1270,
                        settings: {
                            slidesToShow: 4,
                            slidesToShow: 4,
                            adaptiveHeight: true,
                        }
                    },
                ]
            });

            $('.product-ratings-list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list-2');
        if (firstCarrousel) {
            $('.product_list-2').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 577,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.product_list-2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.slick-products').then(element => {
        const widgetProducts = element.querySelector('#widget-products');
        if (widgetProducts) {
            $('#widget-products').slick({
                arrows: true,
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                delay: 5000,
                speed: 700,
            });

            function updateWidgetImageColor() {
                // Seleciona o item ativo dentro do contexto de '.widget-products__list--item'
                const activeItem = $('.widget-products__list--item.slick-active');

                if (activeItem.length > 0) {
                    // Obtém o valor do atributo color-id
                    const colorId = activeItem.attr('color-id');

                    // Verifique se o colorId está definido
                    if (colorId) {
                        // Seleciona a imagem da widget
                        const widgetImage = $('.widget-products__image');
                        const widgetImageBG = $('.widget-products__list');

                        if (widgetImage.length > 0) {
                            // Adiciona o color-id como um style
                            widgetImageBG.css('background-color', colorId);

                            // Atualiza os fills dos SVGs
                            widgetImage.find('svg').attr('fill', colorId);
                        }
                    }
                }
            }

            // Evento 'init' para inicialização do slick
            $('#widget-products').on('init', function () {
                updateWidgetImageColor();
            });

            // Evento 'afterChange' para atualizar a cor quando o slide ativo mudar
            $('#widget-products').on('afterChange', function () {
                updateWidgetImageColor();
            });
        }
    });

    waitForElementToExist('.slick-taste').then(element => {
        const widgetWhosTaste = element.querySelector('#widget-whos-taste');
        if (widgetWhosTaste) {
            $('#widget-whos-taste').slick({
                arrows: false,
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            arrows: true
                        }
                    }
                ]
            });

            const allVideos = document.querySelectorAll('.widget-whos-taste__list--item video'),
                  allMutes = document.querySelectorAll('.widget-whos-taste__list--item .mute');
            if (allVideos && allMutes) {
                allVideos.forEach((video) => {
                    const container = video.parentElement;

                    video.muted = true;
                    video.play().then(() => {
                      video.pause();
                    }).catch(() => {
                      // falhou, mas tudo bem — o hover vai funcionar depois
                    });
                  
                    container.addEventListener('mouseenter', () => video.play());
                    container.addEventListener('mouseleave', () => video.pause());
                });
                
                allMutes.forEach((mute) => {
                    const container = mute.parentElement;

                    mute.addEventListener('click', () => {
                        const video = container.querySelector('video');
                        video.muted = !video.muted;
                        mute.classList.toggle('active');
                    });
                });
            }


        }
    });

    waitForElementToExist('.slick-rating').then(element => {
        const homeRatings = element.querySelector('.product-ratings-list');
        if (homeRatings) {
            $('.product-ratings-list').slick({
                arrows: true,
                dots: true,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 577,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 5,
                        }
                    }
                ]
            });
        }
    });
})
